import React, { useState, useEffect, ReactElement } from 'react';
import ContactItem from './contact-item';
import { get, stickyKitRecalc } from '../utils';
import { RemoteContact } from '../types';
import ErrorMessageBoundary from '../errors/error-message-boundary';

export interface ContactInfoProps {
  organizationId?: string;
  group?: string;
}

export default function ContactInfo(props: ContactInfoProps): ReactElement {
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState<RemoteContact[]>([]);
  useEffect(() => {
    let group = '';
    if (props.group) {
      group = `&group=${encodeURIComponent(props.group)}`;
    }
    setLoading(true);
    get<RemoteContact[]>(`/api/sxk/contacts?organizationId=${encodeURIComponent(props.organizationId)}${group}`)
      .then((data) => {
        setContacts(data || []);
      })
      .catch((ex) => {
        console.error('parsing contact information failed', ex);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [props.group, props.organizationId]);
  useEffect(() => {
    stickyKitRecalc();
  });

  return (
    <ErrorMessageBoundary name="contact-info" errorIsClearable>
      <div className="media-feed contact-information">
        <div className="media-feed-scroll-outer">
          <div className="scroll-wrapper media-feed-scroll scrollbar-inner">
            <div>
              <span className={loading ? 'spinner ajax-progress-fullscreen' : ''} />
              {contacts.map((a) => (
                <ContactItem key={a.email} {...a} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </ErrorMessageBoundary>
  );
}
